import { useState } from 'react';
import { motion } from 'framer-motion';
import { ChipIcon } from './ChipIcon';

interface BuyInModalProps {
  minBuyIn: number;
  maxBuyIn: number;
  maxAvailable: number;
  tableName: string;
  onConfirm: (amount: number) => void;
  onCancel: () => void;
}

export function BuyInModal({ minBuyIn, maxBuyIn, maxAvailable, tableName, onConfirm, onCancel }: BuyInModalProps) {
  const cap = Math.min(maxBuyIn, maxAvailable);
  const [amount, setAmount] = useState(Math.min(cap, Math.round((minBuyIn + maxBuyIn) / 2)));
  const insufficientFunds = maxAvailable < minBuyIn;

  return (
    <div className="fixed inset-0 z-40 bg-black/70 backdrop-blur-sm flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        style={{
          backgroundImage: `linear-gradient(rgba(20,23,26,0.93), rgba(20,23,26,0.97)), url(/textures/metal-black.jpg)`,
        }}
        className="w-full max-w-xs bg-cover bg-center rounded-2xl p-5 border border-gold-500/20 shadow-goldGlow"
      >
        <div className="font-display font-bold text-gold-gradient text-lg mb-1">{tableName}</div>
        <div className="text-white/40 text-xs mb-4">Выберите бай-ин фишками</div>

        {insufficientFunds ? (
          <div className="text-rose-300 text-sm mb-4">
            Недостаточно фишек для минимального бай-ина ({minBuyIn.toLocaleString('ru-RU')})
          </div>
        ) : (
          <>
            <div className="flex items-center justify-center gap-1.5 text-2xl font-bold text-gold-400 tabular-nums mb-2">
              <ChipIcon size={20} />
              {amount.toLocaleString('ru-RU')}
            </div>
            <input
              type="range"
              min={minBuyIn}
              max={cap}
              step={Math.max(1, Math.round((cap - minBuyIn) / 50) || 1)}
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
              className="w-full accent-emerald-400 mb-4"
            />
            <div className="flex justify-between text-[11px] text-white/40 mb-4">
              <span>{minBuyIn.toLocaleString('ru-RU')}</span>
              <span>{cap.toLocaleString('ru-RU')}</span>
            </div>
          </>
        )}

        <div className="flex gap-2">
          <button
            onClick={onCancel}
            className="flex-1 py-2.5 rounded-xl bg-ink-700 text-white/70 text-sm font-medium"
          >
            Отмена
          </button>
          <button
            disabled={insufficientFunds}
            onClick={() => onConfirm(amount)}
            className="flex-1 py-2.5 rounded-xl bg-gradient-to-b from-gold-400 to-gold-600 text-ink-950 text-sm font-bold disabled:opacity-40"
          >
            Сесть за стол
          </button>
        </div>
      </motion.div>
    </div>
  );
}
